export default __webpack_public_path__ + "static/media/netflix.d5d7431e.jpg";